import { createContext, useState } from "react";

const ManageProfileContext = createContext();

export const ManageProfileProvider = ({ children }) => {
  const [subscriptionDetails, setSubsciptionDetails] = useState({});

  return (
    <ManageProfileContext.Provider
      value={{ subscriptionDetails, setSubsciptionDetails }}
    >
      {children}
    </ManageProfileContext.Provider>
  );
};

export default ManageProfileContext;
